import request from './index'

export const getLoginData = (username, password, code) => {
  return request({
    url: '/do_login',
    method: 'post',
    data: {
      command_id: 4,
      username,
      password,
      code
    }
  })
}

export const getMenuData = (roleId) => {
  return request({
    url: '/menu/list',
    method: 'post',
    data: {
      roleId
    }
  })
}

export const doLogout = () => {
  return request({
    url: '/do_logout',
    method: 'get',
    data: {

    }
  })
}
